import { useRef, useState, useEffect } from "react";
import ChannelConnection from "../../js/connection/ChannelConnection";
import FeatureLockedButton from "../subscription/FeatureLockedButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAddressBook,
    faCog,
    faCommentDots,
    faMicrophone,
    faUserPlus,
    faVideo,
    faUsers
} from "@fortawesome/free-solid-svg-icons";
import { Button, Columns, Modal, Box } from "react-bulma-components";
import ScreenshareToggle from "./ScreenshareToggle";
// import InvitePeopleModal from "./InvitePeopleModal";
import { useParams } from "react-router";
import ChannelSettingsModal from "./ChannelSettingsModal";
// import CallUserModal from "./CallUserModal";
import axios from "axios";

export default function ChannelToolbar({
    connection,
    isChatOpened,
    isMobileView,
    toggleChatOpened,
    isThumbnailsOpened,
    toggleThumbnailsOpened,
}: {
    connection: ChannelConnection;
    isChatOpened: boolean;
    isMobileView: boolean;
    toggleChatOpened: () => void;
    isThumbnailsOpened: boolean;
    toggleThumbnailsOpened: () => void;
}) {
    // State to force a render of components
    const [, forceRender] = useState({});
    const [showInviteModal, setInviteModal] = useState(false);
    const [showCallModal, setCallModal] = useState(false);
    const [showSettingsModal, setSettingsModal] = useState(false);
    //HBx
    const [showHoloBoxModal, setShowHoloBoxModal] = useState(false);
    const [devices, setDevices] = useState<any[]>([]);
    const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const baseUrl = "https://34.60.197.231/api"; // replace with your API base URL
    const accessToken = localStorage.getItem("authToken");
    const refreshToken = localStorage.getItem("refreshToken");

    const channelId = useRef(useParams().id);

    function onToggleVideoClick() {
        connection.toggleLocalVideo();
        forceRender({});
    }

    function onToggleAudioClick() {
        connection.toggleLocalAudio();
        forceRender({});
    }

    function onToggleScreenshareClick() {
        connection.screenshare.toggleScreenshare();
        forceRender({});
    }

    async function ensureAccessToken() {
        //const accessToken = localStorage.getItem("authToken");
        //const refreshToken = localStorage.getItem("refreshToken");

        if (true){//!accessToken || !refreshToken) {
        try {
            const res = await axios.post(`${baseUrl}/auth/login`, {
            email: "admin@holoray.com",
            password: "HoloRayAdmin"
            }, {
            headers: {
                "Content-Type": "application/json"
            }
            });

            // Replace `res.data` fields with exact response structure
            localStorage.setItem("authToken", res.data.data.authToken);
            localStorage.setItem("refreshToken", res.data.data.refreshToken);
            console.log("Authenticated and tokens stored.");
        } catch (err) {
            console.error("Login failed", err);
            alert("Could not log in. Please check credentials or server.");
        }
        }
    };

    async function fetchDevices() {
        ensureAccessToken();
        try {
            const res = await axios.get(`${baseUrl}/devices`, {
                headers: { Authorization: `Bearer ${accessToken}` }, withCredentials: false
            });
            setDevices(res.data.data);
            console.log("HERERERRERERERER",devices)
            setShowHoloBoxModal(true);
        } catch (err) {
            console.error("Error fetching devices", err);
            alert("Failed to load HoloBox devices.");
        }
    }

    async function sendStartCommand() {
        console.log("selectedDeviceId:",selectedDeviceId);
        if (!selectedDeviceId) return;
        setLoading(true);
        try {
            await axios.post(`${baseUrl}/mqtt/send-command`, {
                command: "START",
                deviceId: selectedDeviceId,
                sessionID: channelId.current,
            }, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            alert("Command sent to device.");
            setShowHoloBoxModal(false);
        } catch (err) {
            console.error("Error sending command", err);
            alert("Failed to send command.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="channel-toolbar-container">
            <Columns breakpoint="mobile" className="channel-toolbar" style={{ 
                padding: isMobileView ? '0.5rem' : '1rem',
                margin: 0,
                alignItems: 'center'
            }}>
                <Columns.Column narrow className="toolbar-column">
                    <Button.Group className="toolbar-button-group">
                        {/* <div className={isMobileView ? "mobile-button-wrapper" : ""}>
                            <FeatureLockedButton
                                feature=""
                                color="link"
                                rounded
                                data-tooltip="Invite people"
                                onClick={() => setInviteModal(true)}>
                                <FontAwesomeIcon icon={faUserPlus} />
                            </FeatureLockedButton>
                        </div> */}
                        {/* <div className={isMobileView ? "mobile-button-wrapper" : ""}>
                            <FeatureLockedButton
                                feature=""
                                color="link"
                                rounded
                                data-tooltip="Call another user"
                                onClick={() => setCallModal(true)}>
                                <FontAwesomeIcon icon={faAddressBook} />
                            </FeatureLockedButton>
                        </div> */}
                        {/* <div className={isMobileView ? "mobile-button-wrapper" : ""}>
                            <Button
                                color="link"
                                rounded
                                data-tooltip="Send HoloBox Command"
                                onClick={fetchDevices}>
                                📦
                            </Button>
                        </div> */}
                    </Button.Group>
                </Columns.Column>

                <Columns.Column className="toolbar-column">
                    <Button.Group className={`toolbar-button-group ${isMobileView ? 'mobile-group' : ''}`}>
                        <div className={isMobileView ? "mobile-button-wrapper" : ""}>
                            <Button
                                color={connection.isLocalVideoEnabled ? "primary" : ""}
                                rounded
                                data-tooltip="Toggle local video"
                                onClick={onToggleVideoClick}>
                                <FontAwesomeIcon icon={faVideo} />
                            </Button>
                        </div>
                        <div className={isMobileView ? "mobile-button-wrapper" : ""}>
                            <Button
                                color={connection.isLocalAudioEnabled ? "primary" : ""}
                                rounded
                                data-tooltip="Toggle local audio"
                                onClick={onToggleAudioClick}>
                                <FontAwesomeIcon icon={faMicrophone} />
                            </Button>
                        </div>
                        <div className={isMobileView ? "mobile-button-wrapper" : ""}>
                            <ScreenshareToggle
                                connection={connection}
                                onClick={onToggleScreenshareClick}
                            />
                        </div>
                        <div className={isMobileView ? "mobile-button-wrapper" : ""}>
                            <Button
                                color={isThumbnailsOpened ? "primary" : ""}
                                rounded
                                data-tooltip="Toggle thumbnails"
                                onClick={toggleThumbnailsOpened}>
                                <FontAwesomeIcon icon={faUsers} />
                            </Button>
                        </div>
                        <div className={isMobileView ? "mobile-button-wrapper" : ""}>
                            <Button
                                color={isChatOpened ? "primary" : ""}
                                rounded
                                data-tooltip="Toggle chat"
                                onClick={toggleChatOpened}>
                                <FontAwesomeIcon icon={faCommentDots} />
                            </Button>
                        </div>
                        <div className={isMobileView ? "mobile-button-wrapper" : ""}>
                            <Button
                                color="dark"
                                rounded
                                data-tooltip="Settings"
                                onClick={() => setSettingsModal(true)}>
                                <FontAwesomeIcon icon={faCog} />
                            </Button>
                        </div>
                    </Button.Group>
                </Columns.Column>
            </Columns>

            {/* {showInviteModal && (
                <InvitePeopleModal
                    channel={channelId.current!}
                    onClose={() => setInviteModal(false)}
                />
            )} */}

            {/* {showCallModal && (
                <CallUserModal onClose={() => setCallModal(false)} />
            )} */}

            {showSettingsModal && (
                <ChannelSettingsModal
                    localMedia={connection.getLocalMedia()}
                    onClose={() => setSettingsModal(false)}
                />
            )}

            {showHoloBoxModal && (
                <Modal show onClose={() => setShowHoloBoxModal(false)}>
                    <Modal.Card>
                        <Modal.Card.Header>
                            <Modal.Card.Title>Select a HoloBox</Modal.Card.Title>
                        </Modal.Card.Header>
                        <Modal.Card.Body>
                            {devices.length === 0 ? (
                                <p>No devices found.</p>
                            ) : (
                                <Box>
                                    {devices.map(device => (
                                        <div
                                            key={device.id}
                                            className={`box ${selectedDeviceId === device.id ? 'has-background-info-light' : ''}`}
                                            style={{ cursor: "pointer", marginBottom: "0.5rem" }}
                                            onClick={() => setSelectedDeviceId(device.id)}>
                                            <strong>{device.deviceName}</strong> — {device.location?.hospital || 'Unknown'}
                                        </div>
                                    ))}
                                </Box>
                            )}
                        </Modal.Card.Body>
                        <Modal.Card.Footer>
                            <Button color="success" disabled={!selectedDeviceId || loading} onClick={sendStartCommand}>
                                {loading ? "Sending..." : "Confirm"}
                            </Button>
                            <Button color="danger" onClick={() => setShowHoloBoxModal(false)}>
                                Cancel
                            </Button>
                        </Modal.Card.Footer>
                    </Modal.Card>
                </Modal>
            )}

            <style>{`
                .channel-toolbar-container {
                    background: var(--background-color);
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                }
                
                .channel-toolbar {
                    background: transparent;
                }
                
                .toolbar-column {
                    padding: 0.25rem 0.5rem;
                    display: flex;
                    justify-content: center;
                }
                
                .toolbar-button-group {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                }
                
                .mobile-group {
                    flex-wrap: wrap;
                    gap: 0.25rem;
                }
                
                .mobile-button-wrapper {
                    width: 2.5rem;
                    height: 2.5rem;
                }
                
                .mobile-button-wrapper button {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0;
                }
                
                @media (max-width: 768px) {
                    .toolbar-column {
                        padding: 0.25rem;
                    }
                }
            `}</style>
        </div>
    );
}
